import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { User } from '../models/user';
import { UserService } from '../services/user.service';
import { Router } from '@angular/router';
import { MatSnackBar } from "@angular/material";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  model: User = new User();
  logged$: Observable<boolean>;
  logged: boolean = false;
  loading: boolean = false;

  constructor(private modelService: UserService, private route: Router, private snackBar: MatSnackBar) { }

  ngOnInit() {
    this.logged$ = this.modelService.getLogin$();
    this.logged$.subscribe(val => this.logged = val);

    this.checkLogin();
  }

  checkLogin() {
    this.modelService.checkLogin()
  }

  login() {
    this.loading = true;
    this.modelService.login(this.model).subscribe(
      val => {
        this.modelService.setLogin(val);
        this.loading = false;
      },
      error => {
        this.snackBar.open('Intente de nuevo, Código o Clave incorrectos', '', {
          duration: 3000,
          panelClass: ['red-snackbar']
        });
        this.loading = false;
        //console.log(<any>error);
      });
  }
}
